import React from "react";
import { string, number, bool, oneOfType } from "prop-types";

const SpecialPrice = ({ price, specialPrice, buyNow }) => {
    const localeCurrency = {
        style: "currency",
        currency: "USD"
    };

    const priceDisplay = typeof price != "string" ? price > 0 ? price.toLocaleString("en-US", localeCurrency) : "Please Inquire" : price;

    return (
        <div className="price">
            <div>
                <span className={specialPrice ? "strikethrough" : undefined}>Price: {priceDisplay}</span>
                {(buyNow && !specialPrice) && <span><i className="fas fa-shopping-cart ml-2 color-placeholder"></i></span>}
            </div>
            <div className="on-sale">
                {specialPrice && <span>On Sale: {Number(specialPrice).toLocaleString("en-US", localeCurrency)}</span>}
                {(buyNow && specialPrice) && <span><i className="fas fa-shopping-cart ml-2 color-placeholder"></i></span>}
            </div>
        </div>
    );
};

SpecialPrice.propTypes = {
    price: oneOfType([number, string]),
    specialPrice: oneOfType([bool, string]),
    buyNow: bool
};

SpecialPrice.defaultProps = {
    specialPrice: false,
    price: 0,
    buyNow: false
};

export default SpecialPrice;
